"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DeleteFill_exports = {};
__export(DeleteFill_exports, {
  default: () => DeleteFill_default
});
module.exports = __toCommonJS(DeleteFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.00781 6.55859C5.82552 6.55859 5.67578 6.63021 5.55859 6.77344C5.44141 6.90365 5.39583 7.0599 5.42188 7.24219L7.14062 16.6953C7.19271 16.9948 7.33594 17.2422 7.57031 17.4375C7.80469 17.6198 8.07161 17.7109 8.37109 17.7109H12.6289C12.9284 17.7109 13.1953 17.6198 13.4297 17.4375C13.6641 17.2422 13.8073 16.9948 13.8594 16.6953L15.5781 7.24219C15.6042 7.0599 15.5586 6.90365 15.4414 6.77344C15.3242 6.63021 15.1745 6.55859 14.9922 6.55859H6.00781ZM7.25781 4.03906C7.25781 3.70052 7.38151 3.40755 7.62891 3.16016C7.8763 2.91276 8.16927 2.78906 8.50781 2.78906H12.4922C12.8307 2.78906 13.1237 2.91276 13.3711 3.16016C13.6185 3.40755 13.7422 3.70052 13.7422 4.03906V4.58594H15.6758C15.806 4.58594 15.9167 4.63802 16.0078 4.74219C16.112 4.83333 16.1641 4.95052 16.1641 5.09375C16.1641 5.22396 16.112 5.34115 16.0078 5.44531C15.9167 5.53646 15.806 5.58203 15.6758 5.58203H5.32422C5.19401 5.58203 5.07682 5.53646 4.97266 5.44531C4.88151 5.34115 4.83594 5.22396 4.83594 5.09375C4.83594 4.95052 4.88151 4.83333 4.97266 4.74219C5.07682 4.63802 5.19401 4.58594 5.32422 4.58594H7.25781V4.03906Z",
      fill: "currentColor"
    }
  )
);
const SvgDeleteFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DeleteFill_default = SvgDeleteFill;
